
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.287.506h11.776L13.52 2.03H3.287c-.493 0-.943.207-1.27.542a1.856 1.856 0 00-.528 1.3v12.753c0 .506.202.966.529 1.3.326.334.776.541 1.27.541h12.461c.494 0 .944-.207 1.27-.541.326-.334.529-.794.529-1.3V7.11l1.489-1.514v11.03c0 .926-.37 1.767-.966 2.376a3.24 3.24 0 01-2.322.988H3.287a3.238 3.238 0 01-2.322-.988A3.39 3.39 0 010 16.626V3.872c0-.927.37-1.768.965-2.378A3.243 3.243 0 013.287.506"}}),_c('path',{staticClass:"st0",attrs:{"d":"M6.52 10.934l9.149-9.364 2.788 2.853-9.15 9.365zM19.733 1.79L18.24.265a.903.903 0 00-1.295 0l-.648.663 2.788 2.853.648-.663a.956.956 0 000-1.326M5.243 15.093l.33-1.711.33-1.713 1.342 1.375L8.59 14.42l-1.673.337z"}})])
          )
        }
      }
    